/* Policy pages — enhances Shopify's default policy markup:
   - widens via policy.css
   - injects a sidebar with cross-policy links + an auto "On this page" TOC
   - wraps wide tables so they scroll on mobile
   - scroll-spy highlights the current section */
(function () {
  var POLICIES = [
    ['Privacy Policy', '/policies/privacy-policy'],
    ['Refund Policy', '/policies/refund-policy'],
    ['Shipping Policy', '/policies/shipping-policy'],
    ['Terms of Service', '/policies/terms-of-service']
  ];

  function slug(s) {
    return s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function init() {
    var container = document.querySelector('.shopify-policy__container') || document.querySelector('.pol');
    if (!container || container.dataset.polBound === 'true') return;
    container.dataset.polBound = 'true';

    var content =
      container.querySelector('.shopify-policy__body .rte') ||
      container.querySelector('[data-pol-content]') ||
      container.querySelector('.rte');
    if (!content) return;

    /* Wrap tables for horizontal scroll on small screens */
    Array.prototype.slice.call(content.querySelectorAll('table')).forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('pol__table-scroll')) return;
      var w = document.createElement('div');
      w.className = 'pol__table-scroll';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    var heads = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

    /* Build sidebar */
    var aside = document.createElement('aside');
    aside.className = 'pol__aside';

    var nav = document.createElement('nav');
    nav.className = 'pol__nav';
    nav.setAttribute('aria-label', 'Policies');
    var navTitle = document.createElement('span');
    navTitle.className = 'pol__nav-title';
    navTitle.textContent = 'Policies';
    nav.appendChild(navTitle);
    var navUl = document.createElement('ul');
    navUl.className = 'pol__nav-list';
    var path = location.pathname.replace(/\/$/, '');
    POLICIES.forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'pol__nav-link';
      a.href = p[1];
      a.textContent = p[0];
      if (path === p[1]) {
        a.classList.add('is-current');
        a.setAttribute('aria-current', 'page');
      }
      li.appendChild(a);
      navUl.appendChild(li);
    });
    nav.appendChild(navUl);
    aside.appendChild(nav);

    /* Build "On this page" TOC */
    if (heads.length) {
      var toc = document.createElement('nav');
      toc.className = 'pol__toc';
      var tocTitle = document.createElement('span');
      tocTitle.className = 'pol__toc-title';
      tocTitle.textContent = 'On this page';
      toc.appendChild(tocTitle);
      var tocUl = document.createElement('ul');
      tocUl.className = 'pol__toc-list';
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'pol-' + i + '-' + (slug(h.textContent) || 'section');
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.dataset.target = h.id;
        a.className = 'pol__toc-link' + (h.tagName === 'H3' ? ' pol__toc-link--sub' : '');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(h.id);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + h.id);
          }
        });
        li.appendChild(a);
        tocUl.appendChild(li);
      });
      toc.appendChild(tocUl);
      aside.appendChild(toc);
    }

    /* Wrap content + sidebar into a grid (unless our own template already did) */
    if (!container.querySelector('.pol__layout')) {
      var layout = document.createElement('div');
      layout.className = 'pol__layout';
      content.parentNode.insertBefore(layout, content);
      layout.appendChild(aside);
      content.classList.add('pol__content');
      layout.appendChild(content);
    }

    /* Scroll-spy */
    if (heads.length && 'IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(aside.querySelectorAll('.pol__toc-link'));
      var setActive = function (id) {
        links.forEach(function (l) { l.classList.toggle('is-active', l.dataset.target === id); });
      };
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) setActive(entry.target.id); });
      }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });
      heads.forEach(function (h) { obs.observe(h); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
